import React, { useEffect, useState } from 'react'

import Input from 'components/Input'
import ShowPasswordIcon from 'assets/icons/show-password-trailing-icon'
import HidePasswordIcon from 'assets/icons/hide-password-trailing-icon'

const PasswordInput = ({ value, marginBottomLabel, ...props }) => {
  const [isPasswordHidden, setIsPasswordHidden] = useState(false)
  const trailingIcon = isPasswordHidden ? <ShowPasswordIcon opacity={value ? '1' : '0.5'} /> : <HidePasswordIcon />
  const togglePasswordDisplay = () => {
    setIsPasswordHidden((s) => {
      return !s
    })
  }

  useEffect(() => {
    if(!value){
      setIsPasswordHidden(false)
    }
  }, [value])

  return (
    <div data-testid='test-password-input'>
      <Input
        {...props}
        value={value}
        type={isPasswordHidden ? 'text' : 'password'}
        trailingIcon={value ? trailingIcon : <ShowPasswordIcon opacity={value ? '1' : '0.5'} />}
        trailingIconAction={togglePasswordDisplay}
        marginBottomLabel={marginBottomLabel}
      />
    </div>
  )
}

export default PasswordInput
